import React from 'react';
import {
    FlatButton, RaisedButton, Table, TableBody, TableHeaderColumn, TableRow, TableRowColumn
} from "material-ui";
import * as ArticleDetailsState from "../../general/article-details-state";

export default class ArticlesTable extends React.Component {

    render() {
        return (
            <div>
                <Table
                    selectable={false}
                    fixedHeader={false}
                    style={{width: '100%'}}
                >
                    <TableBody
                        displayRowCheckbox={false}
                        showRowHover={true}
                    >
                        <TableRow>
                            <TableHeaderColumn>Referat</TableHeaderColumn>
                            <TableHeaderColumn>Cod articol</TableHeaderColumn>
                            <TableHeaderColumn>Denumire articol</TableHeaderColumn>
                            <TableHeaderColumn>Detalii articol</TableHeaderColumn>
                            <TableHeaderColumn>Pret unitar</TableHeaderColumn>
                            <TableHeaderColumn>Cantitate</TableHeaderColumn>
                            <TableHeaderColumn>Stare</TableHeaderColumn>
                            <TableHeaderColumn>Detalii</TableHeaderColumn>
                        </TableRow>

                        {this.props.data.map((el, i) => {
                            let articleName;
                            if (el.articleDetails && el.articleDetails.realArticleName) {
                                articleName = el.articleDetails.realArticleName;
                            } else {
                                articleName = el.product.name;
                            }
                            return <TableRow key={el.id}>

                                {
                                    el.paper ?
                                        <TableRowColumn>
                                            <FlatButton
                                                primary
                                                label={"REFERAT"}
                                                onClick={() => this.props.onSeePaperClicked(el)}/>
                                        </TableRowColumn>
                                        : <TableRowColumn>
                                            <div>
                                                {!el.paper && this.props.user.canEditAcquisitionsReports
                                                && <RaisedButton
                                                    secondary
                                                    label={"STERGE"}
                                                    onClick={() => this.props.onDeleteClicked(el)}/>}
                                            </div>
                                        </TableRowColumn>
                                }

                                {el.paper
                                    ? <TableRowColumn>{el.paper.yearId + " / " + el.paper.createdYear + " / " + el.orderId}</TableRowColumn>
                                    : <TableRowColumn></TableRowColumn>}

                                <TableRowColumn>{articleName}</TableRowColumn>

                                <TableRowColumn>{el.details}</TableRowColumn>

                                <TableRowColumn>{el.articleDetails && el.articleDetails.realPricePerUnit ? el.articleDetails.realPricePerUnit : el.pricePerUnit}</TableRowColumn>

                                <TableRowColumn>{el.articleDetails && el.articleDetails.realQuantity ? el.articleDetails.realQuantity : el.quantity}</TableRowColumn>

                                <TableRowColumn>
                                    {<div style={{marginTop: '5px', marginBottom: '5px'}}>
                                        <div>
                                            {el.articleDetails && ArticleDetailsState.isAcquisitionDone(el.articleDetails.acquisitionState)
                                                ? <strong style={{color: '#008000'}}>Achizitii: Complet</strong>
                                                : <strong style={{color: '#FF0000'}}>Achizitii: Incomplet</strong>}
                                        </div>


                                        <div>
                                            {el.articleDetails && ArticleDetailsState.isAccountingDone(el.articleDetails.accountingState)
                                                ? <strong style={{color: '#008000'}}>Conta: Complet</strong>
                                                : <strong style={{color: '#FF0000'}}>Conta: Incomplet</strong>}
                                        </div>

                                        <div>
                                            {el.articleDetails && ArticleDetailsState.isReceptionDone(el.articleDetails.receptionState)
                                                ? <strong style={{color: '#008000'}}>Magazie: Complet</strong>
                                                : <strong style={{color: '#FF0000'}}>Magazie: Incomplet</strong>}
                                        </div>
                                    </div>}
                                </TableRowColumn>


                                <TableRowColumn>
                                    <div>
                                        <FlatButton
                                            primary
                                            label={"Detalii"}
                                            onClick={() => this.props.onEditClicked(el)}/>
                                    </div>
                                </TableRowColumn>
                            </TableRow>
                        })}
                    </TableBody>


                </Table>
            </div>
        )
    };

};